import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { extensions, ExtensionType } from '@pixi/core';
import { BackgroundLoader } from './BackgroundLoader.mjs';
import { Cache } from './cache/Cache.mjs';
import { Loader } from './loader/Loader.mjs';
import { Resolver } from './resolver/Resolver.mjs';
import { convertToList } from './utils/convertToList.mjs';
import { isSingleItem } from './utils/isSingleItem.mjs';
var AssetsClass = /*#__PURE__*/function () {
  function AssetsClass() {
    _classCallCheck(this, AssetsClass);
    this._detections = [];
    this._initialized = false;
    this.resolver = new Resolver();
    this.loader = new Loader();
    this.cache = Cache;
    this._backgroundLoader = new BackgroundLoader(this.loader);
    this._backgroundLoader.active = true;
    this.reset();
  }
  _createClass(AssetsClass, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _options$texturePrefe, _options$texturePrefe2, _options$texturePrefe3;
        var options,
          manifest,
          resolutionPref,
          resolution,
          formats,
          _options$texturePrefe4,
          formatPref,
          _iterator,
          _step,
          detection,
          _iterator2,
          _step2,
          _detection,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              if (!this._initialized) {
                _context.next = 4;
                break;
              }
              console.warn("[Assets]AssetManager already initialized, did you load before calling this Asset.init()?");
              return _context.abrupt("return");
            case 4:
              this._initialized = true;
              if (options.basePath) {
                this.resolver.basePath = options.basePath;
              }
              if (!options.manifest) {
                _context.next = 13;
                break;
              }
              manifest = options.manifest;
              if (!(typeof manifest === "string")) {
                _context.next = 12;
                break;
              }
              _context.next = 11;
              return this.load(manifest);
            case 11:
              manifest = _context.sent;
            case 12:
              this.resolver.addManifest(manifest);
            case 13:
              resolutionPref = (_options$texturePrefe = (_options$texturePrefe2 = options.texturePreference) === null || _options$texturePrefe2 === void 0 ? void 0 : _options$texturePrefe2.resolution) !== null && _options$texturePrefe !== void 0 ? _options$texturePrefe : 1;
              resolution = typeof resolutionPref === "number" ? [resolutionPref] : resolutionPref;
              formats = [];
              if (!((_options$texturePrefe3 = options.texturePreference) !== null && _options$texturePrefe3 !== void 0 && _options$texturePrefe3.format)) {
                _context.next = 42;
                break;
              }
              formatPref = (_options$texturePrefe4 = options.texturePreference) === null || _options$texturePrefe4 === void 0 ? void 0 : _options$texturePrefe4.format;
              formats = typeof formatPref === "string" ? [formatPref] : formatPref;
              _iterator = _createForOfIteratorHelper(this._detections);
              _context.prev = 20;
              _iterator.s();
            case 22:
              if ((_step = _iterator.n()).done) {
                _context.next = 32;
                break;
              }
              detection = _step.value;
              _context.next = 26;
              return detection.test();
            case 26:
              if (_context.sent) {
                _context.next = 30;
                break;
              }
              _context.next = 29;
              return detection.remove(formats);
            case 29:
              formats = _context.sent;
            case 30:
              _context.next = 22;
              break;
            case 32:
              _context.next = 37;
              break;
            case 34:
              _context.prev = 34;
              _context.t0 = _context["catch"](20);
              _iterator.e(_context.t0);
            case 37:
              _context.prev = 37;
              _iterator.f();
              return _context.finish(37);
            case 40:
              _context.next = 63;
              break;
            case 42:
              _iterator2 = _createForOfIteratorHelper(this._detections);
              _context.prev = 43;
              _iterator2.s();
            case 45:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 55;
                break;
              }
              _detection = _step2.value;
              _context.next = 49;
              return _detection.test();
            case 49:
              if (!_context.sent) {
                _context.next = 53;
                break;
              }
              _context.next = 52;
              return _detection.add(formats);
            case 52:
              formats = _context.sent;
            case 53:
              _context.next = 45;
              break;
            case 55:
              _context.next = 60;
              break;
            case 57:
              _context.prev = 57;
              _context.t1 = _context["catch"](43);
              _iterator2.e(_context.t1);
            case 60:
              _context.prev = 60;
              _iterator2.f();
              return _context.finish(60);
            case 63:
              this.resolver.prefer({
                params: {
                  format: formats,
                  resolution: resolution
                }
              });
            case 64:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[20, 34, 37, 40], [43, 57, 60, 63]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "add",
    value: function add(keysIn, assetsIn, data) {
      this.resolver.add(keysIn, assetsIn, data);
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(urls, onProgress) {
        var _this = this;
        var singleAsset, urlArray, resolveResults, out;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this._initialized) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return this.init();
            case 3:
              singleAsset = isSingleItem(urls);
              urlArray = convertToList(urls).map(function (url) {
                if (typeof url !== "string") {
                  _this.resolver.add(url.src, url);
                  return url.src;
                }
                return url;
              });
              resolveResults = this.resolver.resolve(urlArray);
              _context2.next = 8;
              return this._mapLoadToResolve(resolveResults, onProgress);
            case 8:
              out = _context2.sent;
              return _context2.abrupt("return", singleAsset ? out[urlArray[0]] : out);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "addBundle",
    value: function addBundle(bundleId, assets) {
      this.resolver.addBundle(bundleId, assets);
    }
  }, {
    key: "loadBundle",
    value: function () {
      var _loadBundle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(bundleIds, onProgress) {
        var _this2 = this;
        var singleAsset, resolveResults, out, keys, count, total, _onProgress, promises;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this._initialized) {
                _context3.next = 3;
                break;
              }
              _context3.next = 3;
              return this.init();
            case 3:
              singleAsset = false;
              if (typeof bundleIds === "string") {
                singleAsset = true;
                bundleIds = [bundleIds];
              }
              resolveResults = this.resolver.resolveBundle(bundleIds);
              out = {};
              keys = Object.keys(resolveResults);
              count = 0;
              total = 0;
              _onProgress = function _onProgress() {
                onProgress === null || onProgress === void 0 ? void 0 : onProgress(++count / total);
              };
              promises = keys.map(function (bundleId) {
                var resolveResult = resolveResults[bundleId];
                total += Object.keys(resolveResult).length;
                return _this2._mapLoadToResolve(resolveResult, _onProgress).then(function (resolveResult2) {
                  out[bundleId] = resolveResult2;
                });
              });
              _context3.next = 14;
              return Promise.all(promises);
            case 14:
              return _context3.abrupt("return", singleAsset ? out[bundleIds[0]] : out);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadBundle(_x3, _x4) {
        return _loadBundle.apply(this, arguments);
      }
      return loadBundle;
    }()
  }, {
    key: "backgroundLoad",
    value: function () {
      var _backgroundLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(urls) {
        var resolveResults;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this._initialized) {
                _context4.next = 3;
                break;
              }
              _context4.next = 3;
              return this.init();
            case 3:
              if (typeof urls === "string") {
                urls = [urls];
              }
              resolveResults = this.resolver.resolve(urls);
              this._backgroundLoader.add(Object.values(resolveResults));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function backgroundLoad(_x5) {
        return _backgroundLoad.apply(this, arguments);
      }
      return backgroundLoad;
    }()
  }, {
    key: "backgroundLoadBundle",
    value: function () {
      var _backgroundLoadBundle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(bundleIds) {
        var _this3 = this;
        var resolveResults;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this._initialized) {
                _context5.next = 3;
                break;
              }
              _context5.next = 3;
              return this.init();
            case 3:
              if (typeof bundleIds === "string") {
                bundleIds = [bundleIds];
              }
              resolveResults = this.resolver.resolveBundle(bundleIds);
              Object.values(resolveResults).forEach(function (resolveResult) {
                _this3._backgroundLoader.add(Object.values(resolveResult));
              });
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function backgroundLoadBundle(_x6) {
        return _backgroundLoadBundle.apply(this, arguments);
      }
      return backgroundLoadBundle;
    }()
  }, {
    key: "reset",
    value: function reset() {
      this.resolver.reset();
      this.loader.reset();
      this.cache.reset();
      this._initialized = false;
    }
  }, {
    key: "get",
    value: function get(keys) {
      if (typeof keys === "string") {
        return Cache.get(keys);
      }
      var assets = {};
      for (var i = 0; i < keys.length; i++) {
        assets[i] = Cache.get(keys[i]);
      }
      return assets;
    }
  }, {
    key: "_mapLoadToResolve",
    value: function () {
      var _mapLoadToResolve2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(resolveResults, onProgress) {
        var resolveArray, resolveKeys, loadedAssets, out;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              resolveArray = Object.values(resolveResults);
              resolveKeys = Object.keys(resolveResults);
              this._backgroundLoader.active = false;
              _context6.next = 5;
              return this.loader.load(resolveArray, onProgress);
            case 5:
              loadedAssets = _context6.sent;
              this._backgroundLoader.active = true;
              out = {};
              resolveArray.forEach(function (resolveResult, i) {
                var asset = loadedAssets[resolveResult.src];
                var keys = [resolveResult.src];
                if (resolveResult.alias) {
                  keys.push.apply(keys, _toConsumableArray(resolveResult.alias));
                }
                out[resolveKeys[i]] = asset;
                Cache.set(keys, asset);
              });
              return _context6.abrupt("return", out);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function _mapLoadToResolve(_x7, _x8) {
        return _mapLoadToResolve2.apply(this, arguments);
      }
      return _mapLoadToResolve;
    }()
  }, {
    key: "unload",
    value: function () {
      var _unload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(urls) {
        var urlArray, resolveResults;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this._initialized) {
                _context7.next = 3;
                break;
              }
              _context7.next = 3;
              return this.init();
            case 3:
              urlArray = convertToList(urls).map(function (url) {
                return typeof url !== "string" ? url.src : url;
              });
              resolveResults = this.resolver.resolve(urlArray);
              _context7.next = 7;
              return this._unloadFromResolved(resolveResults);
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function unload(_x9) {
        return _unload.apply(this, arguments);
      }
      return unload;
    }()
  }, {
    key: "unloadBundle",
    value: function () {
      var _unloadBundle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(bundleIds) {
        var _this4 = this;
        var resolveResults, promises;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (this._initialized) {
                _context8.next = 3;
                break;
              }
              _context8.next = 3;
              return this.init();
            case 3:
              bundleIds = convertToList(bundleIds);
              resolveResults = this.resolver.resolveBundle(bundleIds);
              promises = Object.keys(resolveResults).map(function (bundleId) {
                return _this4._unloadFromResolved(resolveResults[bundleId]);
              });
              _context8.next = 8;
              return Promise.all(promises);
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function unloadBundle(_x10) {
        return _unloadBundle.apply(this, arguments);
      }
      return unloadBundle;
    }()
  }, {
    key: "_unloadFromResolved",
    value: function () {
      var _unloadFromResolved2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(resolveResult) {
        var resolveArray;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              resolveArray = Object.values(resolveResult);
              resolveArray.forEach(function (resolveResult2) {
                Cache.remove(resolveResult2.src);
              });
              _context9.next = 4;
              return this.loader.unload(resolveArray);
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function _unloadFromResolved(_x11) {
        return _unloadFromResolved2.apply(this, arguments);
      }
      return _unloadFromResolved;
    }()
  }, {
    key: "detections",
    get: function get() {
      return this._detections;
    }
  }]);
  return AssetsClass;
}();
var Assets = new AssetsClass();
extensions.handleByList(ExtensionType.LoadParser, Assets.loader.parsers).handleByList(ExtensionType.ResolveParser, Assets.resolver.parsers).handleByList(ExtensionType.CacheParser, Assets.cache.parsers).handleByList(ExtensionType.DetectionParser, Assets.detections);
export { Assets, AssetsClass };